module.exports = __webpack_public_path__ + "media/images/homepage/hero-6c4982730743600043e3f346092959e1.jpg";